import { useAuthContext } from "../context/AuthContext";

/**
 * This middleware will check if the role type of the user is one of the given types
 * @param {string|string[]} types for example: "superadmin" or ["superadmin", "user"]
 * @returns {{ validate: function, redirect: function }}
 */
function useRoleTypeMiddleware(types) {
  types = Array.isArray(types) ? types : [types];
  const authContext = useAuthContext();

  /**
   * This method will validate the middleware
   * @returns {boolean}
   */
  function validate() {
    const userRoleType = authContext.auth.user?.role_type;
    return userRoleType !== undefined && types.includes(userRoleType);
  }

  /**
   * This method return the redirect instructions on fail
   * @returns {{ to: string, replace: boolean }}
   */
  function redirect() {
    if (authContext.auth.user?.role_type === "terminal") {
      return { to: "/frontoffice", replace: true };
    }
    return { to: "/dashboard", replace: true };
  }

  //return the middleware
  return { validate, redirect };
}

export default useRoleTypeMiddleware;
